module.exports = __webpack_public_path__ + "img/clock-twelve-thirty.db2e8ee6.svg";